export const shortcuts = [
  { shortcut: 'Go to previous frame', key: 'A' },
  { shortcut: 'Go to next frame', key: 'D' },
  { shortcut: 'Jump forward several frames', key: 'Shift + D' },
  { shortcut: 'Jump backward several frames', key: 'Shift + A' },
  { shortcut: 'Save current frame', key: 'F' },
  { shortcut: 'Delete saved frame', key: 'Delete' },
  { shortcut: 'Navigate up in saved frames', key: 'Arrow Up' },
  { shortcut: 'Navigate down in saved frames', key: 'Arrow Down' },
  { shortcut: 'Select saved frame', key: 'Enter' },
];

export const frameType = {
  startFrame: 'start_frame',
  endFrame: 'end_frame',
};

export const sliderVideoMenuItems = {
  remove: 'Remove Video',
};

export const mergeVideosShortcuts = [
  { shortcut: 'Go to previous frame', key: 'Arrow Down' },
  { shortcut: 'Go to next frame', key: 'Arrow Up' },
  { shortcut: 'Delete cycle range', key: 'Delete' },
  { shortcut: 'Navigate up in file list', key: 'A' },
  { shortcut: 'Navigate down in file list', key: 'D' },
  { shortcut: 'Select cycle', key: 'Space' },
];
